export default __webpack_public_path__ + "static/media/oracle.ecdadc1c.png";